import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import useOnScreen from '../../functional-components/Advertising/useOnScreen'
import { logEventToDataCollection } from '../../data-tagging'
import { EVENTS } from '../../data-tagging/constants'
import { sendClickPromoDataToAnalytics } from '../../common/GoogleTagManager'

const Index = (props) => {
  const { internal, link, categoryName, title, index, image, name } = props

  const reference = useRef()
  const visible = useOnScreen(reference)

  useEffect(() => {
    if (visible) {
      logEventToDataCollection({
        eventName: EVENTS.VIEW_SLICK_SLIDER,
        data: {
          imageName: `${categoryName}__${name}`,
          origin: title,
          index: parseInt(index, 0) + 1,
        },
      })
    }
  }, [visible])

  return internal ? (
    <Link
      to={link}
      onClick={() => {
        sendClickPromoDataToAnalytics(`${categoryName}__${name}`, title, parseInt(index, 0) + 1)
      }}
    >
      <div className="categories-menu-item-se text-center" ref={reference}>
        <div className="d-flex justify-content-center">
          <img alt={name} src={image} />
        </div>
        <div className="d-flex justify-content-center">
          <h3 className="categories-menu-item-text-se">{name}</h3>
        </div>
      </div>
    </Link>
  ) : (
    <a
      key={name}
      href={link}
      ref={reference}
      onClick={() => {
        sendClickPromoDataToAnalytics(`${categoryName}__${name}`, title, parseInt(index, 0) + 1)
      }}
    >
      <div className="categories-menu-item-se text-center">
        <div className="d-flex justify-content-center">
          <img alt={name} src={image} />
        </div>
        <div className="d-flex justify-content-center">
          <h3 className="categories-menu-item-text-se">{name}</h3>
        </div>
      </div>
    </a>
  )
}

Index.defaultProps = {
  internal: '',
  link: '',
  categoryName: '',
  title: '',
  index: 0,
  image: '',
  name: '',
}

Index.propTypes = {
  internal: PropTypes.string,
  link: PropTypes.string,
  categoryName: PropTypes.string,
  title: PropTypes.string,
  index: PropTypes.number,
  image: PropTypes.string,
  name: PropTypes.string,
}

export default Index
